(() => {

    class ValetInsuranceModal {

        constructor() {

            this.modal = document.querySelector(
                "[data-valet-insurance-modal]"
            );

            if (!this.modal) return;

            this.overlay =
                this.modal.querySelector(
                    "[data-modal-close]"
                );

            this.boxContainer =
                this.modal.querySelector(
                    "[data-insurance-boxes]"
                );

            this.backButton =
                this.modal.querySelector(
                    "[data-insurance-back]"
                );

            this.continueButton =
                this.modal.querySelector(
                    "[data-insurance-continue]"
                );

            this.variants = JSON.parse(

                this.modal.querySelector(
                    "[data-insurance-variants]"
                ).textContent

            );

            this.bindEvents();

        }

        /*
        |--------------------------------------------------------------------------
        | Open
        |--------------------------------------------------------------------------
        */

        open() {

            this.renderBoxes();

            this.modal.hidden = false;

            document.body.classList.add(
                "overflow-hidden"
            );

        }

        /*
        |--------------------------------------------------------------------------
        | Close
        |--------------------------------------------------------------------------
        */

        close() {

            this.modal.hidden = true;

            document.body.classList.remove(
                "overflow-hidden"
            );

        }

        /*
        |--------------------------------------------------------------------------
        | Generate Box Rows
        |--------------------------------------------------------------------------
        */

        renderBoxes() {

            this.boxContainer.innerHTML = "";

            const quantity = Number(

                document.querySelector(
                    "[data-valet-quantity]"
                )?.value || 1

            );

            for (let i = 1; i <= quantity; i++) {

                const row =
                    document.createElement("div");

                row.className =
                    "valet-insurance-modal__box";

                const label =
                    document.createElement("label");

                label.className =
                    "valet-insurance-modal__box-label";

                label.textContent =
                    `Box #${i}`;

                const select =
                    document.createElement("select");

                select.className =
                    "valet-insurance-modal__box-select";

                select.dataset.box = i;

                const noInsurance = document.createElement("option");

                noInsurance.value = "";

                noInsurance.textContent = "No Additional Protection";

                noInsurance.dataset.title = "No Additional Protection";

                noInsurance.dataset.price = 0;

                select.appendChild(noInsurance);

                this.variants.forEach(variant => {

                    const option =
                        document.createElement("option");

                    option.value =
                        variant.id;

                    option.textContent =

                        variant.price > 0

                            ? `${variant.title} (${variant.display_price})`

                            : variant.title;

                    option.dataset.title =
                        variant.title;

                    option.dataset.price =
                        variant.price;

                    select.appendChild(option);

                });

                row.appendChild(label);

                row.appendChild(select);

                this.boxContainer.appendChild(row);

            }

        }

        /*
        |--------------------------------------------------------------------------
        | Events
        |--------------------------------------------------------------------------
        */

        bindEvents() {

            /*
            |--------------------------------------------------------------------------
            | Overlay
            |--------------------------------------------------------------------------
            */

            this.overlay.addEventListener(

                "click",

                () => this.close()

            );

            /*
            |--------------------------------------------------------------------------
            | No Thanks
            |--------------------------------------------------------------------------
            */

            this.backButton.addEventListener(

                "click",

                () => {

                    window.valetBooking.insurance = [];

                    this.boxContainer
                        .querySelectorAll("select")
                        .forEach(select => {

                            const option =
                                select.options[0];

                            window.valetBooking.insurance.push({

                                box:
                                    Number(
                                        select.dataset.box
                                    ),

                                variantId:
                                    Number(option.value),

                                title:
                                    option.dataset.title,

                                price:
                                    Number(
                                        option.dataset.price
                                    )

                            });

                        });

                    this.close();

                    if (window.ValetNavigation) {

                        window.ValetNavigation.showStep(3);

                    }

                }

            );

            /*
            |--------------------------------------------------------------------------
            | Add Insurance
            |--------------------------------------------------------------------------
            */

            this.continueButton.addEventListener(

                "click",

                () => {

                    window.valetBooking.insurance = [];

                    this.boxContainer
                        .querySelectorAll("select")
                        .forEach(select => {

                            const option =
                                select.selectedOptions[0];

                            window.valetBooking.insurance.push({

                                box:
                                    Number(
                                        select.dataset.box
                                    ),

                                variantId:
                                    Number(option.value),

                                title:
                                    option.dataset.title,

                                price:
                                    Number(
                                        option.dataset.price
                                    )

                            });

                        });

                    this.close();

                    window.ValetNavigation.showStep(3);

                }

            );

        }

    }

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            window.ValetInsuranceModal =
                new ValetInsuranceModal();

        }

    );

})();